import {
  SupplierList,
  SupplierAccount,
  SupplierAddress
} from "~/views/Supplier/index";
import Layout from "~/layout/index.vue";

const SupplierRoutes = {
  path: "/supplier",
  component: Layout,
  children: [
    {
      path: "",
      name: "supplierList",
      component: SupplierList,
      meta: {
        title: '供应商',
        isBack: true,
        isHeaderShow: true
      }
    },
    {
      path: "account",
      name: "supplierAccount",
      component: SupplierAccount,
      meta: {
        title: '供应商账户',
        isBack: true,
        isHeaderShow: true
      }
    },
    {
      path: "address",
      name: "supplierAddress",
      component: SupplierAddress,
      meta: {
        title: '供应商地址',
        isBack: true,
        isHeaderShow: true
      }
    }
  ]
};



export { SupplierRoutes };
